module.exports = __webpack_public_path__ + "static/image_9_thumb-94fa3c2444bd9c4399bf3bac130a49e2.jpg";